module.exports = __webpack_public_path__ + "static/media/81oopJz9BJL._AC_UX569_.791a59fc.jpg";